<template>
  <el-table-column
    prop="edi_desadv_id"
    sortable="custom"
    label="Kapcsolódó DESADV"
    show-overflow-tooltip
    min-width="220"
  >
    <template slot-scope="scope">
      <el-link
        v-if="scope.row.edi_desadv_id"
        type="primary"
        @click.stop="$router.push('/sales/desadvs/view/' + scope.row.edi_desadv_id)"
      >
        <el-icon name="view" />
        {{ label(scope.row) }}
      </el-link>
      <el-tag v-else size="small" type="warning">Nincs kapcsolódó DESADV</el-tag>
    </template>
  </el-table-column>
</template>

<script>
export default {
  propName: 'edi_desadv_id',
  methods: {
    // The DESADV has no receipt number of its own: the DESADV/2026/xx numbers are
    // per truck and stay on its detail page. It is named by the order it despatches.
    label(row) {
      return row.customer_order_receipt_number
        ? `${row.customer_order_receipt_number} DESADV`
        : `DESADV #${row.edi_desadv_id}`;
    },
  },
};
</script>
